export default __webpack_public_path__ + "f5c51f7729a4ba3743398818ddc7c0bf.png";